import bill100 from "../../../images/cash/100_dollar.png";
import bill50 from "../../../images/cash/50_dollar.png";
import bill20 from "../../../images/cash/20_dollar.png";
import bill10 from "../../../images/cash/10_dollar.png";
import bill5 from "../../../images/cash/5_dollar.png";
import bill1 from "../../../images/cash/1_dollar.png";
import coin1 from "../../../images/cash/1_dollar_bronze.png";
import coin50c from "../../../images/cash/50_cents.png";
import coin25c from "../../../images/cash/25_cents.png";
import coin10c from "../../../images/cash/10_cents.png";
import coin5c from "../../../images/cash/5_cents.png";
import coin1c from "../../../images/cash/1_cent.png";

export const DENOMINATIONS = [
  { id: "bill100", label: "100 Dollars", value: 100, type: "bill", image: bill100 },
  { id: "bill50", label: "50 Dollars", value: 50, type: "bill", image: bill50 },
  { id: "bill20", label: "20 Dollars", value: 20, type: "bill", image: bill20 },
  { id: "bill10", label: "10 Dollars", value: 10, type: "bill", image: bill10 },
  { id: "bill5", label: "5 Dollars", value: 5, type: "bill", image: bill5 },
  { id: "bill1", label: "1 Dollar", value: 1, type: "bill", image: bill1 },
  { id: "coin1", label: "1 Dollar", value: 1, type: "coin", image: coin1 },
  { id: "coin50c", label: "50 Cents", value: 0.5, type: "coin", image: coin50c },
  { id: "coin25c", label: "25 Cents", value: 0.25, type: "coin", image: coin25c },
  { id: "coin10c", label: "10 Cents", value: 0.1, type: "coin", image: coin10c },
  { id: "coin5c", label: "5 Cents", value: 0.05, type: "coin", image: coin5c },
  { id: "coin1c", label: "1 Cent", value: 0.01, type: "coin", image: coin1c },
];
